import { Booking } from "../../declarations/booking";
import { IoClose } from "react-icons/io5";

export const BookingDetailsModal = ({
  booking,
  onClose,
}: {
  booking: Booking[];
  onClose: any;
}) => {
  console.log("booking", booking);
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      {/* Modal Content */}
      <div className="w-full max-w-3xl bg-white rounded-lg shadow-lg relative ">
        {/* Modal Header */}
        <div className="flex justify-between items-center bg-blue-50 p-5 ">
          <h2 className="text-xl font-semibold">View Booking Details</h2>
          <button
            onClick={onClose}
            className="text-gray-900 hover:text-gray-600 text-2xl"
          >
            <IoClose />
          </button>
        </div>

        {/* Modal Body */}

        {booking.map((book: Booking, index: number) => (
          <div className=" p-12" key={index}>
            <h3 className="text-2xl font-bold mb-5">
              {book.package?.title}{" "}
              <span
                className={`inline-block text-sm ${
                  book.status === "pending"
                    ? "bg-yellow-100 text-yellow-600"
                    : book.status === "approved"
                    ? "bg-green-100 text-green-600"
                    : book.status === "declined"
                    ? "bg-red-100 text-red-600"
                    : ""
                }  px-5 py-1 rounded`}
              >
                {book.status}
              </span>
            </h3>

            <div className="flex justify-between  pb-2 text-sm border-b-4 border-b-blue-700 border p-3 rounded-tr-md rounded-tl-md items-center">
              <div className="flex flex-col my-3">
                <div className="flex mb-3">
                  <p className="text-gray-500 px-2">Booked by:</p>
                  <p className="font-medium">
                    {book.bookedBy?.firstName} {book.bookedBy?.lastName}{" "}
                  </p>
                </div>
                <div className="flex">
                  <p className="text-gray-500 px-2">Package owner:</p>
                  <p className="font-medium">
                    {book.packageOwner?.firstName} {book.packageOwner?.lastName}
                  </p>
                </div>
              </div>

              <div className="flex">
                <p className="text-gray-500 px-2">Total Adults</p>
                <p className="font-medium">{book.totalAdults}</p>
              </div>
              <div className="flex">
                <p className="text-gray-500 px-2">Total Infants</p>
                <p className="font-medium">{book.totalInfants}</p>
              </div>
            </div>

            <div className="grid grid-cols-4 gap-4  text-sm text-gray-700 bg-blue-50  py-4 px-3">
              <div>
                <p className="text-gray-500 mb-2">Payment time</p>
                <p className="font-medium">
                  {book.paymentTime === "pay_now"
                    ? "Pay Now"
                    : book.paymentTime}
                </p>
              </div>
              <div>
                <p className="text-gray-500 mb-2">Base amount</p>
                <p className="font-medium">{book.baseAmount} USD</p>
              </div>
              <div>
                <p className="text-gray-500 mb-2">Calculated amount</p>
                <p className="font-medium">{book.calculatedAmount} USD</p>
              </div>
              <div>
                <p className="text-gray-500 mb-2">Marked up amount</p>
                <p className="font-medium">{book.markedUpAmount} USD</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
